import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=d191be80&scoped=true&"
import script from "./copyright.vue?vue&type=script&lang=js&"
export * from "./copyright.vue?vue&type=script&lang=js&"
import style0 from "./copyright.vue?vue&type=style&index=0&id=d191be80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d191be80",
  null
  
)

export default component.exports